var map = {
	"./config.development": 413,
	"./config.development.js": 413,
	"./config.private": 352,
	"./config.private.js": 352,
	"./config.production": 414,
	"./config.production.js": 414,
	"./config.staging": 415,
	"./config.staging.js": 415,
	"./config.test": 416,
	"./config.test.js": 416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;